import type { ReactNode } from "react";

interface Props {
  title: string;
  badge?: string;
  subtitle?: string;
  className?: string;
  children: ReactNode;
}

export function PanelCard({ title, badge, subtitle, className, children }: Props) {
  return (
    <div className={`card panel-card${className ? ` ${className}` : ""}`}>
      <div className="panel-header">
        <div className="panel-header-title">
          <h2>{title}</h2>
          {badge && <span className="panel-badge">{badge}</span>}
        </div>
        {subtitle && <span className="panel-subtitle">{subtitle}</span>}
      </div>
      {children}
    </div>
  );
}
